import { boltSection } from "./Power_WB_1_BoltSection";
import { base_color } from "./Power_WB_settings.js";

//基础剖面图绘制

export function profile(
  g, //在哪个g内定义剖面的symbol容器,
  params_geometry, //几何参数
  params_bolt, //螺栓参数
  x, //中心顶部定位坐标
  y,
  scale_width = 100
) {
  let [R, R1, R2, H1, H2, H3] = params_geometry.slice(0, 6);
  let holeDepth = params_geometry.find((item) => item.name === "holeDepth");
  let holeRadius = params_geometry.find((item) => item.name === "holeRadius");
  let holeCushionThick = params_geometry.find(
    (item) => item.name === "holeCushionThick"
  );
  let cushionThick = params_geometry.find(
    (item) => item.name === "cushionThick"
  );

  let Bd_in = params_bolt.find((item) => item.name === "Bd_in");
  let Br_in = params_bolt.find((item) => item.name === "Br_in");
  let BPlate_in = params_bolt.find((item) => item.name === "BPlate_in");
  let Bd_out = params_bolt.find((item) => item.name === "Bd_out");
  let Br_out = params_bolt.find((item) => item.name === "Br_out");
  let BPlate_out = params_bolt.find((item) => item.name === "BPlate_out");
  let Grout_thick = params_bolt.find((item) => item.name === "Grout_thick");

  let H = H1.value * 1000 + H2.value * 1000 + H3.value * 1000;

  let b = 1; //基本线宽
  // 0定义剖面的symbol容器
  let profile = g
    .group()
    .addClass("profile")
    .translate(x, y)
    .stroke({ color: "white", width: 0.25 * b * scale_width })
    .fill("none");

  // 1. 绘制中心线
  profile.line({
    x1: 0,
    y1: -400,
    x2: 0,
    y2: H1.value * 1000 + H2.value * 1000 + H3.value * 1000 + (holeDepth.value + holeCushionThick.value) * 1000 + 500,
    "stroke-dasharray": "1000 250 100 250",
    stroke: "red",
  });

  // 2绘制剖面
  let H_groove = holeDepth.value * 1000; // 中心凹槽深度
  let thick_groove = holeCushionThick.value * 1000; // 中心凹槽厚度


  let p1x = holeRadius.value * 1000;

  let p1y = H + H_groove + thick_groove;
  let p2x = p1x + (H_groove + thick_groove - cushionThick.value * 1000);
  let p2y = p1y - (H_groove + thick_groove - cushionThick.value * 1000);
  let p3x = p1x - thick_groove * Math.tan((22.5 * Math.PI) / 180);
  let p3y = p1y - thick_groove;
  let p4x = p3x + H_groove;
  let p4y = p3y - H_groove;
  // 基础轮廓线：
  profile
    .polyline([
      [R2.value * 1000, 0],
      [R2.value * 1000, H3.value * 1000],
      [R1.value * 1000, H3.value * 1000],
      [R.value * 1000, H3.value * 1000 + H2.value * 1000],
      [R.value * 1000, H],
      [p4x, p4y],
      [p3x, p3y],
      [-1 * p3x, p3y],
      [-1 * p4x, p4y],
      [-1 * R.value * 1000, H],
      [-1 * R.value * 1000, H3.value * 1000 + H2.value * 1000],
      [-1 * R1.value * 1000, H3.value * 1000],
      [-1 * R2.value * 1000, H3.value * 1000],
      [-1 * R2.value * 1000, 0],
      [R2.value * 1000, 0],
    ])
    .stroke({ width: 0.5 * b * scale_width, color: base_color });

  profile
    .polyline([
      [R.value * 1000, H],
      [R.value * 1000 + 100, H],
      [R.value * 1000 + 100, H + cushionThick.value * 1000],
      [p2x, p2y],
      [p1x, p1y],
      [-p1x, p1y],
      [-p2x, p2y],
      [-R.value * 1000 - 100, H + cushionThick.value * 1000],
      [-R.value * 1000 - 100, H],
      [-R.value * 1000, H],
    ])
    .stroke({ color: base_color });

  // 3绘制锚栓
  let bolt_group = boltSection(
    profile,
    H, //基础总高度
    H_groove, //凹槽深度
    Bd_in,
    Br_in,
    BPlate_in,
    Bd_out,
    Br_out,
    BPlate_out,
    Grout_thick,
    (Br_in.value + Br_out.value) / 2, //定位x坐标
    0 //定位y坐标
  );

  profile.use(bolt_group).move(-(Br_in.value + Br_out.value), 0);

  return profile;
}
